const GADGET_CONFIG = window.finesse.container.Config;
window.finesse.clientservices.ClientServices.init(GADGET_CONFIG);

export const ALL_TASKS_COLECTION_LS_KEY = `${GADGET_CONFIG.id}allTasksConfig`;
export const ACTIVE_TASK_LS_KEY = `${GADGET_CONFIG.id}activeTaskConfig`;

export function getTaskFromLS(taskId) {
    if (window.localStorage) {
        const allTasks = getFromLS(ALL_TASKS_COLECTION_LS_KEY) || [];
        return allTasks.find((taskLS) => taskLS.taskId === taskId);
    }
}
export function saveTaskToLS(key, value) {
    if (!value) return;
    if (window.localStorage) {
        window.localStorage.setItem(
            key,
            JSON.stringify(value)
        );
    }
}
export function removeTaskFromLS(key, taskId) {
    if (window.localStorage) {
        if (key === ALL_TASKS_COLECTION_LS_KEY) {
            const allTasks = getFromLS(ALL_TASKS_COLECTION_LS_KEY) || [];
            const result = allTasks.filter((task) => {
                return task.taskId !== taskId;
            });
            if (result.length) {
                saveTaskToLS(key, result);
            } else {
                window.localStorage.removeItem(key);
            }
        } else if (key === ACTIVE_TASK_LS_KEY) {
            const activeTaskLS = getFromLS(ACTIVE_TASK_LS_KEY);
            if (activeTaskLS && activeTaskLS.taskId === taskId) {
                window.localStorage.removeItem(key);
            }
        }
    }
}

export function getFromLS(key) {
    let result;
    if (window.localStorage) {
        try {
            result = JSON.parse(window.localStorage.getItem(key));
        } catch (e) {
        }
    }
    return result;
}

export function getCustomIconText(mediaType) {
    const text = (mediaType.split('_').slice(0, 2).map((item) => item[0])).join('') || '';
    return text;
}


export function getMediaLayout(dialog, mediaPropertiesLayouts) {
    const mediaPoperties = dialog.getMediaProperties();
    const layoutName = mediaPoperties['user.layout'] || mediaPoperties['user.Layout'];
    let mediaLayout;
    for (const objectId in mediaPropertiesLayouts) {
        if (mediaPropertiesLayouts.hasOwnProperty(objectId)) {
            const layoutData = mediaPropertiesLayouts[objectId].getData();
            if (layoutData.name === layoutName) {
                mediaLayout = layoutData;
                break;
            } else if (layoutData.type === 'DEFAULT') {
                mediaLayout = layoutData;
            }
        }
    }
    return mediaLayout;
}
